import { Component, OnInit } from '@angular/core';
import { PROVINCES } from '../../../data/provinces';
import { Supplier } from '../../../../classes/Supplier';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-edit-supplier',
  templateUrl: './edit-supplier.component.html',
  styleUrls: ['./edit-supplier.component.scss']
})
export class EditSupplierComponent implements OnInit {

  provinces = PROVINCES;

  isSubmitButtonDisabled: boolean = false;
  id: number;
  contentVisible: boolean = false;
  addEmailButtonDisabled: boolean = true;
  editSupplier: Supplier = new Supplier( );

  hasNotes: boolean = false;
  notes: any;
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;

  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  selectParams: any = {
    state: {
      id: 'inputState',
      isRequired: true,
      change: ( event ) => {
        this.editSupplier.state = event.value;
      },
      options: [ { text: '', value: '' } ]
    }
  };

  constructor ( 
    private route: ActivatedRoute,
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Edit Supplier' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;

    this.provinces.forEach( _state => {
      this.selectParams.state.options.push( { text: _state.long, value: _state.short } );
    });
  }

  ngOnInit ( ) { 
    this.route.params.subscribe(params => {
       this.id = +params['id'];
       this.model.getSupplierDataByID( this.id, ( supplier ) => {
         this.contentVisible = true;
         supplier.notes = '';
         this.editSupplier = supplier;
         if ( !this.editSupplier.emails.length ) this.editSupplier.emails = [ '' ];
         this.checkEmail( );
         this.editSupplier.id = this.id;
         this.getNotes( );
       });
    });
  }

  getNotes ( ) {
    this.model.getNotes( 'supplier', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {
    this.model.addNote( 'supplier', this.id, this.editSupplier.notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }


  trackByIndex( index: number, obj: any ): any {
    return index;
  }


  addEmail ( ) {
    this.editSupplier.emails.push( '' );
    this.checkEmail( );
  }

  checkEmail ( ) {
    this.addEmailButtonDisabled = ( this.editSupplier.emails.indexOf( '' ) !== -1 ) ? true : false;
  }

  removeEmail ( _i: number ) {
    this.editSupplier.emails.splice( _i, 1 );
    this.checkEmail( );
  }



  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'Supplier information has been updated successfully', 
      redirect: '/suppliers-list' 
    });
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;

  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    this.model.editSupplier( this.editSupplier, ( response ) => {
      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else if ( _answer == 'exists' ) {
        this.errorCallback( 'Supplier with name "' + this.editSupplier.name + '" already exists' );
        this.global.defaultErrorCallback( 'Supplier with name "' + this.editSupplier.name + '" already exists' );
      } else {
        this.errorCallback( _answer );
        this.global.defaultErrorCallback( _answer );
      }
    });
    return false;
  }
  
  cancelSubmit ( ) {
    this.global.redirect( '/suppliers-list' );
  }

}




// WEBPACK FOOTER //
// /root/anvel/angular/app/components/suppliers/edit-supplier/edit-supplier.component.ts